import { Action, createReducer, on } from '@ngrx/store';
import clone from 'clone';
import { DashboardVisualTarget } from 'src/app/pbir/dashboards/DashboardVisualTarget';
import { DashboardDto, DashboardVisualContentDto, FilterDto, ListUserDashboardDto, ListUserVisualDto, VisualDto } from '../../services/api.services';
import { AppActions } from '../app';
import * as HomeActions from './home.actions';

export interface State {
  loaded: boolean;

  loadingDashboards: boolean;
  dashboards: ListUserDashboardDto[];

  isLoadingVisuals: boolean;
  visuals: ListUserVisualDto[];

  dashboardId: number;

  loadingDashboard: boolean;
  dashboard: DashboardDto | null;
  visualContents: DashboardVisualContentDto[];

  visualId: number;

  loadingVisual: boolean;
  visual: VisualDto | null;

  lastViewedDashboardId: number | undefined;
  lastViewedVisualId: number | undefined;

  hasFocusedVisual: boolean;
  focusedVisual: DashboardVisualTarget;
 
  copyingDashboard: boolean;
  addingDashboard: boolean;

  copyingVisual: boolean;
  addingVisual: boolean;
}

export const initialState: State = {
  loaded: false,

  loadingDashboards: false,
  dashboards: [],

  isLoadingVisuals: false,
  visuals: [],
  dashboardId: 0,

  loadingDashboard: false,
  dashboard: null,
  visualContents: [],

  visualId: 0,

  loadingVisual: false,
  visual: null,

  lastViewedDashboardId: undefined,
  lastViewedVisualId: undefined,

  focusedVisual: null,
  hasFocusedVisual: false,

  copyingDashboard: false,
  addingDashboard: false,

  copyingVisual: false,
  addingVisual: false
}

const homeReducer = createReducer(
  initialState, 


  on(HomeActions.reset, (state) => {
    return {
      ...initialState
    };
  }),
  on(HomeActions.loaded, (state) => {
    return {
      ...state,
      loaded: true
    };
  }),


  on(HomeActions.loadDashboards, (state) => {
    return {
      ...state,
      loadingDashboards: true
    };
  }),
  on(HomeActions.loadDashboardsSuccess, (state, { dashboards }) => {
    return {
      ...state,
      loadingDashboards: false,
      dashboards
    }
  }),
  on(HomeActions.loadDashboardsFailure, (state) => {
    return {
      ...state,
      loadingDashboards: false
    };
  }),

  on(HomeActions.loadVisuals, (state) => {
    return {
      ...state,
      isLoadingVisuals: true
    };
  }),
  on(HomeActions.loadVisualsSuccess, (state, { visuals }) => {
    return {
      ...state,
      isLoadingVisuals: false,
      visuals
    }
  }),
  on(HomeActions.loadVisualsFailure, (state) => {
    return {
      ...state,
      isLoadingVisuals: false
    };
  }),

  on(HomeActions.setNoItem, (state) => {
    return {
      ...state,
      loadingDashboard: false,
      dashboardId: 0,
      loadingVisual: false,
      visualId: 0
    };
  }),


  on(HomeActions.loadDashboard, (state, { dashboardId }) => {
    return {
      ...state,
      loadingDashboard: true,
      dashboardId,

      dashboard: null,
      visualContents: null,

      hasFocusedVisual: false,
      focusedVisual: null,

      visualId: null,
      visual: null,
    };
  }),
  on(HomeActions.loadDashboardSuccess, (state, { dashboard, visualContents }) => {
    return {
      ...state,
      loadingDashboard: false,

      dashboard,
      visualContents,
    };
  }),
  on(HomeActions.loadDashboardFailure, (state) => {
    return {
      ...state,
      loadingDashboard: false      
    };
  }),

  on(HomeActions.loadVisual, (state, { visualId }) => {
    return {
      ...state,
      loadingVisual: true,
      visualId,

      visual: null,

      dashboardId: null,

      dashboard: null,
      visualContents: null,

      hasFocusedVisual: false,
      focusedVisual: null
    }

  }),
  on(HomeActions.loadVisualSuccess, (state, {visual}) => {
    return {
      ...state,
      visual,
      loadingVisual: false,
    }
  }),

  on(HomeActions.loadVisualFailure, (state, { error }) => {
    return {
      ...state,
      loadingVisual: false
    }
  }),

  on(HomeActions.setLastViewedDashboardId, (state, { dashboardId }) => {
    return {
      ...state,
      lastViewedVisualId: undefined,
      lastViewedDashboardId: dashboardId,
    };
  }),

  on(HomeActions.setLastViewedVisualId, (state, { visualId }) => {
    return {
      ...state,
      lastViewedDashboardId: undefined,
      lastViewedVisualId: visualId,
    };
  }),

  on(AppActions.loadSuccess, (state, { userState }) => {
    return {
      ...state,
      lastViewedDashboardId: userState?.lastViewedDashboardId,
      lastViewedVisualId: userState?.lastViewedVisualId
    };
  }),


  on(HomeActions.setFocusedVisual, (state, { visual }) => {
    return {
      ...state,
      focusedVisual: visual,
      hasFocusedVisual: !!visual
    };
  }),


  on(HomeActions.copyDashboard, (state, { dashboardId }) => {
    return {
      ...state,
      copyingDashboard: true
    };
  }),
  on(HomeActions.copyDashboardSuccess, (state, { dashboard }) => {
    return {
      ...state,
      dashboards: [...state.dashboards, dashboard],
      copyingDashboard: false
    };
  }),
  on(HomeActions.copyDashboardFailure, (state, { error }) => {
    return {
      ...state,
      copyingDashboard: false      
    };
  }),

  on(HomeActions.copyVisual, (state, { visualId }) => {
    return {
      ...state,
      copyingVisual: true
    };
  }),
  on(HomeActions.copyVisualSuccess, (state, { visual }) => {
    return {
      ...state,
      visuals: [...state.visuals, visual],
      copyingVisual: false
    };
  }),
  on(HomeActions.copyVisualFailure, (state, { error }) => {
    return {
      ...state,
      copyingVisual: false      
    };
  }),


  on(HomeActions.addDashboard, (state, { dashboardId }) => {
    return {
      ...state,
      addingDashboard: true
    };
  }),
  on(HomeActions.addDashboardSuccess, (state, { dashboardId }) => {
    let dashboards = [...state.dashboards];

    //i see no reason why not to use "find(d=>d.id == dashboardId).home = true" here
    for (let i = 0; i < dashboards.length; ++i) {
      let d = dashboards[i];
      if (d.id === dashboardId) {
        dashboards[i] = {
          ...d,
          home: true
        };

        break;
      }
    }

    return {
      ...state,
      addingDashboard: false,
      dashboards
    };
  }),
  on(HomeActions.addDashboardFailure, (state) => {
    return {
      ...state,
      addingDashboard: false
    };
  }),

  on(HomeActions.addVisual, (state, { visualId }) => {
    return {
      ...state,
      addingVisual: true
    };
  }),
  on(HomeActions.addVisualSuccess, (state, { visualId }) => {
    let visuals = [...state.visuals];

    visuals.find(v => v.id == visualId).home = true;

    return {
      ...state,
      addingVisual: false,
      visuals
    };
  }),
  on(HomeActions.addVisualFailure, (state) => {
    return {
      ...state,
      addingVisual: false
    };
  }),
);

export function reducer(state: State | undefined, action: Action) {
  return homeReducer(state, action);
}
